/* FRAGRAINS — Theme JavaScript */

document.addEventListener('DOMContentLoaded', function() {

  /* ---- Sticky Nav ---- */
  const nav = document.querySelector('.fg-nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  /* ---- Scroll Reveal ---- */
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.fg-reveal').forEach(function(el) {
    observer.observe(el);
  });

  /* ---- Product Filtering ---- */
  const filterBtns = document.querySelectorAll('.fg-filter');
  const productCards = document.querySelectorAll('.fg-card');

  filterBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      filterBtns.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      const cat = btn.dataset.category;

      productCards.forEach(function(card) {
        if (cat === 'all' || card.dataset.category === cat) {
          card.style.display = '';
          card.style.animation = 'fadeInUp 0.5s ease both';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });

  /* ---- Add to Cart Animation ---- */
  const cartCountEl = document.querySelector('.fg-nav__cart-count');
  let cartCount = 0;

  document.querySelectorAll('.fg-add-to-cart').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      cartCount++;
      if (cartCountEl) {
        cartCountEl.textContent = cartCount;
        cartCountEl.style.display = 'flex';
        cartCountEl.style.animation = 'none';
        cartCountEl.offsetHeight;
        cartCountEl.style.animation = 'cartPop 0.3s ease';
      }

      const origText = btn.textContent;
      btn.textContent = '✓ Added';
      btn.style.background = '#27ae60';
      setTimeout(function() {
        btn.textContent = origText;
        btn.style.background = '';
      }, 1500);

      showToast(btn.dataset.product || 'Item');
    });
  });

  function showToast(name) {
    const existing = document.querySelector('.fg-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'fg-toast';
    toast.textContent = '✓ ' + name + ' added to cart';
    document.body.appendChild(toast);

    setTimeout(function() { toast.remove(); }, 2000);
  }

  /* ---- Mobile Menu ---- */
  const hamburger = document.querySelector('.fg-nav__hamburger');
  const mobileMenu = document.querySelector('.fg-mobile-menu');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() {
      mobileMenu.classList.toggle('active');
      document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
    });

    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---- Newsletter Form ---- */
  const signupForm = document.querySelector('.fg-signup__form');
  if (signupForm) {
    signupForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const input = signupForm.querySelector('.fg-signup__input');
      const btn = signupForm.querySelector('.fg-signup__submit');
      if (input && input.value) {
        btn.textContent = '✓ SUBSCRIBED';
        btn.style.background = '#27ae60';
        input.value = '';
        setTimeout(function() {
          btn.textContent = 'SUBSCRIBE';
          btn.style.background = '';
        }, 3000);
      }
    });
  }
});
